// @core/api/endpoints/signature/create_party.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  CreatePartyRequest,
  PartyResponse,
} from '../../../types/signature';

const BASE_PATH = '/signature';

/**
 * Create a signing party
 * Registers a party on a target entity (document/order/task/...). The target is polymorphic via Entity reference. Initial status is DRAFT until an invitation is dispatched.
 */
export async function CreateParty(
  data: CreatePartyRequest,
  options?: RequestOptions
): Promise<PartyResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/parties`;
  const requestOptions = options;
  return client.post<PartyResponse>(requestPath, data, requestOptions);
}
